import common from './settings/common/main'
import production from './settings/production/main'
import suitup from './settings/suitup/main'
import rebase from './settings/rebase/main'
import piola from './settings/piola/main'
import localhost from './settings/localhost/main'
import { getPropertyFromPath, getDomain } from './my_utils.js'

class Settings {
  constructor () {
    this.common = common
    this.production = production
    this.suitup = suitup
    this.rebase = rebase
    this.piola = piola
    this.localhost = localhost
  }

  get (params) {
    const namespace = params.env === undefined ? this.getNamespace() : this.getEnv(params.env)
    const jobTitle = params.job_title === undefined ? 'no_job_title' : params.job_title
    try {
      return this.getPropertyFromPath({ context: this[namespace][jobTitle], path: params.path })
    } catch (error) {
      try {
        return this.getPropertyFromPath({ context: this[namespace].common, path: params.path })
      } catch (error) {
        try {
          return this.getPropertyFromPath({ context: this.common, path: params.path })
        } catch (error) {
          return ''
        }
      }
    }
  }

  getEnv (env) {
    if (env === 'Office') {
      return 'Suitup'
    }
    return env
  }

  getPropertyFromPath (params) {
    const response = getPropertyFromPath(params)
    if (response === undefined) {
      throw response
    }
    return response
  }

  getNamespace () {
    const domains = {
      'accounting.panel.rebase.co.il': 'production',
      'accounting.panel.hasama.online': 'production',
      'www.accounting.panel.hasama.online': 'production',
      'www.accounting.panel.rebase.co.il': 'production',
      localhost: 'localhost'
    }
    const namespace = domains[getDomain()]
    return namespace || 'no_namespace'
  }
}

export default Settings
